__turbopack_context__.v({
  "className": "manrope_41ab019b-module__YMcOAa__className",
  "variable": "manrope_41ab019b-module__YMcOAa__variable",
});
